<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="$refs.table.reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" label="订单编号：">
        <order-drop v-model="queryForm.orderCode" size="mini" :clearable="true"></order-drop>
      </el-form-item>
      <el-form-item prop="materialName" label="物料名称：">
        <el-input v-model="queryForm.materialName" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialColor" label="颜色：">
        <el-input v-model="queryForm.materialColor" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialSize" label="规格：">
        <el-input v-model="queryForm.materialSize" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialAttr1" label="幅宽：">
        <el-input v-model="queryForm.materialAttr1" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item prop="materialAttr2" label="克重：">
        <el-input v-model="queryForm.materialAttr2" size="mini" clearable type="text"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload" size="mini">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="reload" size="mini" :disabled="true">
          (升级中)计划转合同
        </el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="margin:0 0 0 0;">
      <el-button size="mini" type="primary" :disabled="true">(升级中)已选择【{{ orderCart.length }}】</el-button>
    </div>
    <SweetTable url="/erp/purchase/plan" :query-form="queryForm" ref="table" :selection="true" api-version="v2"
                :summaries-column="['totalCount','productCount']" :before-table-binding="beforeTableBinding"
                @selection-change="selHandler">
      <el-table-column label="订单编号" prop="orderCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="物料名称" align="center" prop="product.name"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          label="颜色"
          prop="product.color"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="规格"
          prop="product.size"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="幅宽"
          prop="product.attr1"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="克重"
          prop="product.attr2"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="理论采购数量" width="120" align="center" prop="planCount">
        <template #default="{row}">
          <el-button type="text" @click="$refs.BomPlanTableDialog.init(row.productId,row.orderId)">{{ row.planCount }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="采购订单数量" width="120" align="center" prop="purchaseCount">
        <template #default="{row}">
          <el-button type="text"
                     @click="$refs.PurchaseTableDialog.init({materialId:row.productId,orderId:row.orderId})">
            {{ row.purchaseCount }}
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <BomPlanTableDialog ref="BomPlanTableDialog"></BomPlanTableDialog>
    <PurchaseTableDialog ref="PurchaseTableDialog"></PurchaseTableDialog>
  </div>
</template>

<script>
import BomPlanTableDialog from '@/views/modules/erp/bom/BomPlanTableDialog.vue'
import BigNumber from 'bignumber.js'
import SweetTable from '@/mixins/SweetTable'
import PurchaseTableDialog from '@/views/modules/erp/common/purchase-table-dialog.vue'

export default {
  name: 'PurchasePlan',
  mixins: [SweetTable],
  components: { BomPlanTableDialog, PurchaseTableDialog },
  data () {
    return {
      orderCart: [],
      queryForm: {
        orderCode: null,
        productName: null,
        productColor: null,
        productSize: null,
        productAttr1: null,
        productAttr2: null
      }
    }
  },
  activated () {
    this.reload()
  },
  methods: {
    selHandler (dataList) {
      if (this.$c.isArrayEmpty(dataList)) {
        return
      }
      dataList.forEach(item => {
        if (this.orderCart.find(oc => oc.orderId === item.orderId && oc.productId === item.productId)) {
          return
        }
        this.orderCart.push(item)
      })
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.totalCount = new BigNumber(row.bomCount || 0).multipliedBy(row.productCount || 0).toFixed(3)
      })
    }
  }
}
</script>

<style scoped>

</style>
